module.exports = __webpack_public_path__ + "img/ui-connect.65afabb9.png";